import { createRouter, createWebHistory } from "vue-router";
import Main from "../pages/Main/Main.vue";
import Welcome from "../pages/Welcome/Welcome.vue";

const routes = [
    {
        path: "/",
        name: "default",
        redirect: { name: "search" },
    },
    {
        path: "/search",
        name: "search",
        component: Main,
    },
    {
        path: "/welcome",
        name: "welcome",
        component: Welcome,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;
